import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';

interface IPageRc0011 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    dnlMultiOccurrenceOptions: IMultiOccurrenceOptions;
    daimultiOccurrenceOptions: IMultiOccurrenceOptions;
    dnsMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Rc0011Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass
) {
    const vm: IPageRc0011 = this;


    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false,
            exportation: false,
            suiviModification: false
        },
        formulaire: new Formulaire('LBL_BLC_TXM', [
            new FormulaireItem('txmnumdoc'),
            new FormulaireItem('txmnumref'),
            new FormulaireItem('refcodnom'),
            new FormulaireItem('txmdat'),
        ], { largeurDefaut: 50 })
    };

    vm.dnlMultiOccurrenceOptions = {
        bloc: 'dnl',
        actionsMore: new Menu([
            new MenuItemAction(
                'LBL_BTN_SUPPRIME',
                'BOUSUP',
                () => ({}),
                {
                    fonction: 'BTNSUP',
                    icon: 'delete',
                    iconButton: false,
                    messageConfirmation: 'BOUSUP_MESSAGE',
                    successAction: () => { vm.monoOccurrence.fetchData(); }
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'dnlrefint', largeur: 100 },
            { nom: 'lolnumloc', largeur: 100 },
            { nom: 'loldsc'   , largeur: 180 },
            { nom: 'dnldst'   , largeur: 180 },
            { nom: 'dnlnbrcol', largeur: 120 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dnlnbrcol')
        ])
    };

    vm.dnsMultiOccurrenceOptions = {
        bloc: 'dns',
        colonnesVisibles: [
            { nom: 'dnsrefint', largeur: 120 },
            { nom: 'lolnumloc', largeur: 130 },
            { nom: 'loldsc', largeur: 200 },
            { nom: 'dnsdst', largeur: 200 },
            { nom: 'dnsqte', largeur: 120 },
            { nom: 'dnsqtedst', largeur: 120 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('dnsqte')
        ])
    };

    vm.daimultiOccurrenceOptions = {
        bloc: 'dai',
        colonnesVisibles: [
            { nom: 'dailig', largeur: 80 },
            { nom: 'daiseqave', largeur: 80 },
            { nom: 'dainumcat', largeur: 150 },
            { nom: 'daidsc', largeur: 250 }
        ],
        colonnesFixesDroite: [
            { nom: 'dahqtecmd', largeur: 126 },
            { nom: 'dahqterec', largeur: 126 },
            { nom: 'dahqtedst', largeur: 126 },
            { nom: 'dahqteven', largeur: 126 }
        ],
        multiOccurrenceOptionsEnfant: vm.dnsMultiOccurrenceOptions
    }
}
